import { z } from "zod/v4";
import { clockSchema } from "../club-availability";

// The players × sessions attendance matrix behind /training/{id}. Three flat
// lists rather than a nested grid — the client pivots. Absent RSVP rows mean
// "pending"; the server never fabricates a row for a member who has not
// answered.

export const attendanceSessionSchema = z.object({
	date: z.string(),
	end_time: clockSchema,
	id: z.string().uuid(),
	squad_id: z.string().uuid(),
	squad_name: z.string(),
	start_time: clockSchema,
});

export const attendanceMemberSchema = z.object({
	display_name: z.string(),
	skill_level_id: z.string().uuid().nullable().optional(),
	user_id: z.string().uuid(),
});

// The Go service collapses its richer internal RSVP states onto these five:
// going→yes, not_going→no, maybe→maybe, absent→pending, and the two
// replacement states split — replacement→no (someone is already covering the
// slot) but searching_replacement→searching (nobody is, so an admin still has
// to chase it). That distinction is the whole reason `searching` exists as a
// wire value rather than being folded into "no".
export const rsvpStatusSchema = z.enum(["yes", "no", "maybe", "pending", "searching"]);

export const attendanceRsvpSchema = z.object({
	session_id: z.string().uuid(),
	status: rsvpStatusSchema,
	user_id: z.string().uuid(),
});

export const attendanceMatrixSchema = z.object({
	members: z.array(attendanceMemberSchema),
	rsvps: z.array(attendanceRsvpSchema),
	sessions: z.array(attendanceSessionSchema),
});
